import OAuthHandler from '@/views/appstructure/OAuthHandler';
import oauthCallback from '@/views/shared/oauth/OAuthCallback';

const routes = [
  {
    path: '/oauth/login',
    name: 'OAuthCB',
    component: OAuthHandler
  }
];

const dynamicRoutes = JSON.parse(sessionStorage.getItem('oauthCbRoutes')) || {};
for (const route in dynamicRoutes) {
  if (dynamicRoutes.hasOwnProperty(route)) {
    routes.push({
      path: route,
      component: oauthCallback(dynamicRoutes[route])
    });
  }
}

export default routes;
